import Sloth from '../../components/Sloth';
import "./index.scss"

@Sloth.component({
    defaultOptions : {
        stars: 0
    }
})

export default class CourseCard {
    onInit() {
        const options = this.options;
        $(this.dom).append("<div class='CourseCard-footer'></div>")
        this.renderStars(options.stars)
    }

    renderStars(stars) {

        for (let i=0; i<stars; i++) {
            $(".CourseCard-footer", this.dom).append("<div class='CourseCard-star'></div>")
        }

        for (let i=0; i<5-stars; i++) {
            $(".CourseCard-footer", this.dom).append("<div class='CourseCard-star CourseCard-star_empty'></div>")
        }

    }
}



/** WEBPACK FOOTER **
 ** ./src/CourseCard/index.js
 **/